import { useSelector } from "react-redux";
import { hasPermission } from "utils/permissionUtils";

export const usePermission = () => {
  const { accountType, rolePermissions } = useSelector((state) => state.Auth);

  const can = (module, permissionKey) => {
    if (accountType === "superadmin") return true;
    return hasPermission(rolePermissions, module, permissionKey);
  };

  const canAction = (module) => ({
    canView: can(module, "can_view"),
    canAdd: can(module, "can_create"),
    canEdit: can(module, "can_edit"),
    canDelete: can(module, "can_delete"),
  });

  return { can, canAction };
};
